<template>
    <center>
        <div class="card card-body agatrs-card-style">
            <Header pageTitle="Email Extensions" class="card-container"></Header>

            <div class="row no-bottom-margin">
                <div class="col-md-3 my-auto">
                    <base-button :class="'btn_info'" @click.native="addVisible = true">
                        <i class="tim-icons icon-simple-add"></i>Add Item
                    </base-button>
                </div>
                <!-- Show Search Page "Search Order" Styling -->
                <div class="col-md-3 offset-md-6">
                    <label for="searchBox">Search:</label>
                    <el-input id="searchBox" type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                        placeholder="Search all exts..." @input="getPaginateExts()" v-model="searchQuery"
                        v-b-popover.hover.top="'Search results appear immediately upon typing.'
                            "></el-input>
                </div>
            </div>

            <div class="card border border-secondary rounded border-2" v-if="addVisible">
                <div class="card-body">
                    <div class="row d-flex align-items-start pb-3">
                        <div class="col-md-4 my-2">
                            <label for="nationOptions" class="d-flex align-items-start">Country</label>
                            <el-select id="Country" v-model="add.countryId" readonly="false" class="fullWidth"
                                name="NationOptions">
                                <el-option class="select-primary" v-for="country in allCountries" :label="country.name"
                                    :value="country.countryId" :key="country.countryId"></el-option>
                            </el-select>
                        </div>
                        <div class="col-md-4 my-2">
                            <label for="typeOptions" class="d-flex align-items-start">Type</label>
                            <el-select v-model="add.type" class="fullWidth" readonly="false"
                                name="typeOptions">
                                <el-option value="GOV" class="select-primary">GOV</el-option>
                                <el-option value="PN" class="select-primary">PN</el-option>
                            </el-select>
                        </div>
                        <div class="col-md-4 my-2">
                            <label for="extension" class="d-flex align-items-start">Extension</label>
                            <el-input placeholder="Please type extension" name="extension" v-model="add.ext"></el-input>
                        </div>
                    </div>

                    <div class="row d-flex align-items-end">
                        <div class="col-md-12 my-2">
                            <base-button class="btn btn-fab btn-danger" @click.native="() => {
                                addVisible = false;
                                add = { id: 0, countryId: '', type: '', ext: '' };
                            }
                                ">
                                <i class="tim-icons icon-simple-remove"></i>Cancel
                            </base-button>
                            <base-button class="btn btn-fab btn-success" @click.native="save(add)">
                                <i class="tim-icons icon-check-2"></i>Save
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <card class="card-plain" body-classes="table-full-width">
                    <el-table ref="table" :data="exts.results" :default-sort="{ prop: 'question', order: 'descending' }">
                        <el-table-column :min-width="300" align="left" label="Actions">
                            <div slot-scope="{ row }" class="table-actions">
                                <template v-if="editRowId === row.id">
                                    <el-tooltip content="Cancel Request" :open-delay="300" effect="light" placement="top">
                                        <base-button class="btn btn-fab btn-danger" @click.native="cancel()">
                                            <i class="tim-icons icon-simple-remove"></i>Cancel
                                        </base-button>
                                    </el-tooltip>
                                    <el-tooltip content="Save Changes" :open-delay="300" effect="light" placement="top">
                                        <base-button class="btn btn-fab btn-success" @click.native="save(row)">
                                            <i class="tim-icons icon-check-2"></i>Save
                                        </base-button>
                                    </el-tooltip>
                                </template>
                                <template v-else-if="removeRowId === row.id">
                                    <el-tooltip content="Cancel Request" :open-delay="300" effect="light" placement="top">
                                        <base-button class="btn btn-fab btn-danger" @click.native="removeRowId = -1">
                                            <i class="tim-icons icon-simple-remove"></i>Cancel
                                        </base-button>
                                    </el-tooltip>
                                    <el-tooltip content="Confirm Delete" :open-delay="300" effect="light" placement="top">
                                        <base-button class="btn btn-fab btn-success" @click.native="remove(row.id)">
                                            <i class="tim-icons icon-check-2"></i>Confirm
                                        </base-button>
                                    </el-tooltip>
                                </template>
                                <template v-else>
                                    <el-tooltip content="Remove FAQ Item" :open-delay="300" effect="light" placement="top">
                                        <base-button class="btn btn-fab btn-danger" @click.prevent="removeRowId = row.id">
                                            <i class="tim-icons icon-trash-simple"></i>Remove
                                        </base-button>
                                    </el-tooltip>

                                    <el-tooltip content="Edit FAQ Item" :open-delay="300" effect="light" placement="top">
                                        <base-button class="btn btn-fab btn-default" @click.native="editRowId = row.id">
                                            <i class="tim-icons icon-pencil"></i>Edit
                                        </base-button>
                                    </el-tooltip>
                                </template>
                            </div>
                        </el-table-column>

                        <el-table-column label="Country" property="countryId" min-width="220">
                            <editable-cell :show-input="editRowId === row.id" slot-scope="{ row }"
                                editable-component="el-select" close-event="change" v-model="row.countryId">
                                <span slot="content">
                                    {{ row.nation }}
                                </span>
                                <template slot="edit-component-slot">
                                    <el-option class="select-primary" v-for="country in allCountries" :label="country.name"
                                        :value="country.countryId" :key="country.countryId"></el-option>
                                </template>
                            </editable-cell>
                        </el-table-column>

                        <el-table-column label="Type" property="type" min-width="140">
                            <editable-cell :show-input="editRowId === row.id" slot-scope="{ row }"
                                editable-component="el-select" close-event="change" v-model="row.type">
                                <span slot="content">
                                    {{ row.type }}
                                </span>
                                <template slot="edit-component-slot">
                                    <el-option value="GOV" class="select-primary">GOV</el-option>
                                    <el-option value="PN" class="select-primary">PN</el-option>
                                </template>
                            </editable-cell>
                        </el-table-column>

                        <el-table-column label="Extension" property="ext" min-width="200">
                            <template slot-scope="{ row }">
                                <editable-cell :show-input="editRowId === row.id" v-model="row.ext">
                                    <span slot="content">{{ row.ext }}</span>
                                </editable-cell>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <el-select class="select-primary mb-3 pagination-select" v-model="pageCount"
                            @change="getPaginateExts()" readonly="false" name="PageOptions" placeholder="Per page">
                            <el-option v-for="(item, index) in pageCountOptions" :value="item" class="select-primary"
                                :key="index"></el-option>
                        </el-select>

                        <base-pagination v-model="exts.currentPage" @input="getPaginateExts()" :perPage="exts.pageSize"
                            :pageCount="exts.pageCount">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </center>
</template>
  
<script>
import Header from "@/components/App/Header.vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import { BasePagination, BaseButton, EditableCell } from "@/components";
export default {
    name: "SuperUserExts",
    components: {
        Header,
        BaseButton,
        BasePagination,
        EditableCell,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data: function () {
        return {
            searchQuery: "",
            editRowId: -1,
            removeRowId: -1,
            pageCount: 5,
            pageCountOptions: [5, 10, 20, 50, 100],
            add: { id: 0, countryId: '', type: '', ext: '' },
            addVisible: false,
        };
    },
    computed: {
        ...mapGetters({
            exts: "emailExtension/emailExtensions",
            allCountries: "countries/allCountries"
        }),
    },

    watch: {},
    async created() {
        this.getPaginateExts();
        this.getAllCountries()
            ;
    },
    methods: {
        ...mapActions({
            getAllCountries: "countries/getAllCountries",
            getExts: "emailExtension/getEmailExtensionPaginate",
            saveExt: "emailExtension/saveEmailExtension",
            removeExt: "emailExtension/removeEmailExtension",
        }),
        async cancel() {
            this.getPaginateExts();
            this.editRowId = -1;
        },

        async save(data) {
            let ctx = this;
            this.editRowId = -1;
            this.addVisible = false;
            await this.saveExt(data).then(() => ctx.getPaginateExts());
            this.add = { id: 0, countryId: '', type: '', ext: '' };
        },

        async remove(id) {
            let ctx = this;
            this.removeRowId = -1;
            await this.removeExt(id).then(() => ctx.getPaginateExts());
        },

        async getPaginateExts() {
            let ctx = this;
            return await ctx.getExts({
                pageNumber: ctx.exts.currentPage ? ctx.exts.currentPage : 1,
                pageCount: ctx.pageCount,
                searchText: ctx.searchQuery ? ctx.searchQuery : "",
            });
        },
    },
};
</script>
  
<style scoped></style>
  